var exports = {
  "kJ": "GiftEmbed.module__iconCircle___Z3JQaE",
  "SP": "GiftEmbed.module__iconCircleActive___Z3JQaE",
  "PP": "GiftEmbed.module__iconCircleInactive___Z3JQaE",
  "_O": "GiftEmbed.module__iconCircleDisabled___Z3JQaE",
  "Kk": "GiftEmbed.module__icon___Z3JQaE",
  "m5": "GiftEmbed.module__iconError___Z3JQaE",
  "DD": "GiftEmbed.module__title___Z3JQaE",
  "jn": "GiftEmbed.module__titlePrimary___Z3JQaE",
  "xP": "GiftEmbed.module__titleTertiary___Z3JQaE",
  "S3": "GiftEmbed.module__titleDanger___Z3JQaE",
  "xF": "GiftEmbed.module__subRow___Z3JQaE",
  "Cz": "GiftEmbed.module__helpRow___Z3JQaE",
  "mj": "GiftEmbed.module__skeletonCircle___Z3JQaE",
  "Iz": "GiftEmbed.module__skeletonTitle___Z3JQaE",
  "hI": "GiftEmbed.module__skeletonHelp___Z3JQaE",
  "G3": "GiftEmbed.module__skeletonButton___Z3JQaE",
};

module.exports = exports;
